import { css } from '@emotion/react';
import { breakpoints, margins } from '@spotnana/blocks/src/utils';

export const sticky_container = css`
  position: sticky;
  top: 40px;
  ${margins.yt.m0}

  ${breakpoints.from('tablet')} {
    ${margins.yt.m0}
  }

  ${breakpoints.from('desktop')} {
    margin-top: 54px;
  }
`;
